import React from 'react';
import {useTranslation} from 'react-i18next';

// AGENT: sesiones del agente IA. EXTERNAL: eventos de relación auto-emitidos por el fan-out de
// la extracción (reuniones, decisiones, compromisos, mails). Ambas las renderiza ActivityLogEntry.
const CATEGORY_OPTIONS = [
    {value: '', labelKey: 'activity_log.all_categories'},
    {value: 'BUDGET', labelKey: 'activity_log.category_budget'},
    {value: 'CONFIGURATION', labelKey: 'activity_log.category_configuration'},
    {value: 'ACCOUNTS', labelKey: 'activity_log.category_accounts'},
    {value: 'TEAM', labelKey: 'activity_log.category_team'},
    {value: 'ALERTS', labelKey: 'activity_log.category_alerts'},
    {value: 'INTEGRATIONS', labelKey: 'activity_log.category_integrations'},
    {value: 'REPORTS', labelKey: 'activity_log.category_reports'},
    {value: 'COMMENT', labelKey: 'activity_log.category_comment'},
    {value: 'STATUS', labelKey: 'activity_log.category_status'},
    {value: 'AGENT', labelKey: 'activity_log.category_agent'},
    {value: 'EXTERNAL', labelKey: 'activity_log.category_external'},
    {value: 'MEMORY_OPS', labelKey: 'activity_log.category_memory_ops'},
    {value: 'PLATFORM_CHANGE', labelKey: 'activity_log.category_platform_change'},
];

export function ActivityLogFilterBar({filters, businessUnits, onFilterChange}) {
    const {t} = useTranslation();

    const handleChange = (e) => {
        onFilterChange({...filters, [e.target.name]: e.target.value});
    };

    return (
        <div className="activity-log-filters">
            <div className="filter-field">
                <label>{t('activity_log.all_categories')}</label>
                <select name="category" value={filters.category} onChange={handleChange}>
                    {CATEGORY_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{t(opt.labelKey)}</option>
                    ))}
                </select>
            </div>

            <div className="filter-field">
                <label>{t('activity_log.all_business_units')}</label>
                <select name="bu_id" value={filters.bu_id} onChange={handleChange}>
                    <option value="">{t('activity_log.all_business_units')}</option>
                    {businessUnits.map(bu => (
                        <option key={bu.id} value={bu.id}>{bu.name}</option>
                    ))}
                </select>
            </div>

            <div className="filter-field">
                <label>{t('activity_log.date_from')}</label>
                <input type="date" name="date_from" value={filters.date_from} onChange={handleChange}/>
            </div>

            <div className="filter-field">
                <label>{t('activity_log.date_to')}</label>
                <input type="date" name="date_to" value={filters.date_to} onChange={handleChange}/>
            </div>

            <div className="filter-field -search">
                <label>{t('activity_log.search_placeholder')}</label>
                <input type="text" name="search" value={filters.search} onChange={handleChange}
                       placeholder={t('activity_log.search_placeholder')}/>
            </div>
        </div>
    );
}
